// extracted by mini-css-extract-plugin
export default {"container":"Rj-z","blurb":"Sj-z","links":"Tj-z"};